export default __webpack_public_path__ + "static/media/faq.b91bdf32.webp";